import React, { PureComponent } from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import { range as d3Range } from 'd3-array';

import { loadData, updateValue, updateShowAll } from './VisState';
import './Vis.scss';

import Sharer from '../../Component/Sharer';

const VISIBLE_COUNTRIES = ['Schweiz', 'Luxemburg', 'Finnland', 'Deutschland',  'Malta', 'Slowenien', 'Kroatien', 'Italien', 'Litauen', 'Bulgarien'];

// comp displays country name, price and number of cups
class CountryItem extends PureComponent {
  render() {
    const { price, country, currentValue, visible, showAll } = this.props;
    let numberOfCups = currentValue / price;
    const cups = d3Range(0, Math.ceil(numberOfCups))
      .map((d, i) => {
        let height;

        if (i < numberOfCups - 1 ) {
          height = 1;
        } else {
          height = numberOfCups % 1 === 0 ? 1 : numberOfCups % 1;
        }

        return (
          <div key={`Country_item__${i}`} className="pricevis-cup-wrapper">
            <div className="pricevis-cup" style={{ height: `${height * 100}%` }}></div>
          </div>
        );
      });

    const formattedPrice = `${price.toString().replace('.', ',')}€`;
    let show = null;
    if(showAll){
      show = '';
    }else{
      show = visible ? '' : 'hidden';
    }

    return (
      <div className={`pricevis-item ${show}`}>
        <div className="pricevis-item-info">
          <div>{country}</div>
          <div>{formattedPrice}</div>
        </div>
        <div className="pricevis-item-cups">
          {cups}
        </div>
      </div>
    );
  }
}

class PricesVis extends PureComponent {

  constructor() {
    super();
    this.onSliderChange = this.onSliderChange.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(loadData());
  }

  onSliderChange(v) {
    this.props.dispatch(updateValue(v));
  }

  onButtonClick(){
    this.props.dispatch(updateShowAll(!this.props.showAll));
  }

  render() {
    if (!this.props.data) {
      return null;
    }

    const { data, currentValue, showAll } = this.props;

    let countryItems;
      countryItems = data
        .map(d => {
          const visible = VISIBLE_COUNTRIES.indexOf(d.country) !== -1;
          return <CountryItem {...d} currentValue={currentValue} showAll={showAll} visible={visible} key={`{d.country}_${d.price}`} />
        });

    return (
      <div>
        <div className="pricevis-wrapper">
          <div className="rc-slider-wrapper">
            <div className="rc-slider-label label--left">0,50€</div>
            <Slider
              min={0.5}
              max={10}
              step={0.1}
              defaultValue={this.props.currentValue}
              onChange={this.onSliderChange}
            />
            <div className="rc-slider-label label--right">10,00€</div>
          </div>
          <div className="prices-info--text">Für {this.props.currentValue.toFixed(2).replace('.', ',')}€ bekommen Sie in Deutschland ungefähr {(this.props.currentValue/1.91).toFixed(1).replace('.', ',')} Tassen Kaffee.</div>
          <div className="pricevis-items">
            {countryItems}
          </div>
          <div className={`pricevis--transparent ${showAll ? 'hidden' : ''}`}></div>
        </div>
        <div className={`pricevis--button ${showAll ? 'hide-button' : 'show-button'}`} onClick={this.onButtonClick} >{showAll ? window.config.labels.price_vis_button_active : window.config.labels.price_vis_button_inactive}</div>
        <Sharer
          url={`${window.config.baseUrl}#kaffee-preise`}
          title={window.config.labels.price_vis_sharing_title}
          description={window.config.labels.price_vis_sharing_text}
          image={`${window.config.baseUrl}assets/images/b1_kaffee_preis_share.png`}
        />
      </div>

    );
  }
};

export default PricesVis;



// WEBPACK FOOTER //
// ./src/modules/PricesVis/Vis.js